import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { getCertMasterPlatformAccessKeyCECheck } from 'services';

type CertMasterPlatformAccessKeyCECheckFunction = UseMutateAsyncFunction<
  void,
  IError,
  { key: string; userId: string }
>;

type UseCertMasterPlatformAccessKeyCECheck = [
  CertMasterPlatformAccessKeyCECheckFunction,
  IQueryHookOptions,
];

export const useCertMasterPlatformAccessKeyCECheck =
  (): UseCertMasterPlatformAccessKeyCECheck => {
    const { error, isError, isLoading, mutateAsync } = useMutation<
      void,
      IError,
      { key: string; userId: string }
    >(({ key, userId }: { key: string; userId: string }) =>
      getCertMasterPlatformAccessKeyCECheck(key, userId),
    );

    return [mutateAsync, { error, isError, isLoading }];
  };
